export default {
  estados: [],
  cidades: {},
}
